import { configureStore } from '@reduxjs/toolkit';
import miscReducer from './slices/miscSlice';
import settingsReducer from '../pages/Settings/redux/settingsSlice';
import movieboxReducer from './slices/movieboxSlice';

const store = configureStore({
  reducer: {
    misc: miscReducer,
    settings: settingsReducer,
    moviebox: movieboxReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  }),
  devTools: process.env.NODE_ENV !== 'production'
});

export default store;